import axiosClient from '@/api/axiosClient';
import {
  API_CREATE_TOPIC,
  API_CREATE_TOPICS_ANSWER,
  API_DELETE_TOPIC_ANSWER,
  API_GET_CHAR_CORE,
  API_GET_TOPICS,
  API_GET_TOPICS_ANSWER,
  API_UPDATE_TOPIC,
  API_UPDATE_TOPIC_ANSWER,
} from '@/config/paths/API_PATH';

async function getTopics({ pageSize = 10, offset = 1, name = null, isActive = null }) {
  const { data } = await axiosClient.get(API_GET_TOPICS, {
    params: {
      limit: pageSize,
      offset,
      name,
      is_active: isActive,
    },
  });
  return data;
}

async function createTopic(payload) {
  const { data } = await axiosClient.post(API_CREATE_TOPIC, {
    ...payload,
  });

  return data;
}

async function updateTopic(payload) {
  const { data } = await axiosClient.post(API_UPDATE_TOPIC, {
    ...payload,
  });

  return data;
}

async function getTopicsAnswer({
  pageSize = 10,
  offset = 1,
  fullWordEn = null,
  isActive = null,
  topicId = null,
}) {
  const { data } = await axiosClient.get(API_GET_TOPICS_ANSWER, {
    params: {
      limit: pageSize,
      offset,
      full_word_en: fullWordEn,
      is_active: isActive,
      topic_id: topicId,
    },
  });

  return data;
}

// "is_active", "topic_id", "full_word_en", "full_word_my", "key_word"
async function createTopicsAnswer(payload) {
  const { data } = await axiosClient.post(API_CREATE_TOPICS_ANSWER, {
    ...payload,
  });

  return data;
}
// "is_active", "topic_id", "full_word_en", "full_word_my", "key_word", "id"
async function updateTopicAnswer(payload) {
  const { data } = await axiosClient.post(API_UPDATE_TOPIC_ANSWER, {
    ...payload,
  });

  return data;
}

async function deleteTopicAnswer({ topicAnswerId }) {
  const { data } = await axiosClient.post(API_DELETE_TOPIC_ANSWER, {
    id: topicAnswerId,
  });

  return data;
}

export {
  getTopics,
  createTopic,
  updateTopic,
  getTopicsAnswer,
  createTopicsAnswer,
  updateTopicAnswer,
  deleteTopicAnswer,
};
